UPDATE_USER_ACCOUNT_CANCEL_OFFER_SHOWN